import { styled } from '@mui/material/styles';

const StyledPricingCardHeader = styled('div')`
  text-align: left;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export default StyledPricingCardHeader;
